import { HeronReportStatus } from '@40seas/entities/heron';
import { EnumColor } from '@40seas/frontend/common/providers';

export const heronReportStatusColorMapping = {
    [HeronReportStatus.Failed]: 'error',
    [HeronReportStatus.InProgress]: 'info',
    [HeronReportStatus.Pending]: 'default',
    [HeronReportStatus.Succeeded]: 'success',
} as { [key in HeronReportStatus]: EnumColor };
